// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__qQK99","content":"styles_content__2tTyB","selectAll":"styles_selectAll__3V6v4"};